import React from "react";
import SortButton from "../../Component/SortButton/SortButton";
import "../Product/ProductList.css";

const ProductListHeader = ({
  columnSearch,
  setColumnSearch,
  currentSortColumn,
  currentSortOrder,
  onSortChange,
}) => {
  const renderInputColumn = (label, column) => (
    <div className="product-table-cell">
      <p>
        {label}{" "}
        <SortButton
          column={column}
          currentSortColumn={currentSortColumn}
          currentSortOrder={currentSortOrder}
          onSortChange={onSortChange}
        />
      </p>
      <input
        type="text"
        placeholder="Search"
        value={columnSearch[column]}
        onChange={(e) =>
          setColumnSearch({ ...columnSearch, [column]: e.target.value })
        }
      />
    </div>
  );
   const renderDateColumn = (label, column) => (
  <div>
    <p>
      {label}{" "}
      <SortButton
        column={column}
        currentSortColumn={currentSortColumn}
        currentSortOrder={currentSortOrder}
        onSortChange={onSortChange}
      />
    </p>

    <div style={{ height: "2.17rem" }}></div>
  </div>
);

  return (
    <div className="product-table-row product-table-header">
      <div className="product-table-cell">Sr</div>
      <div className="product-table-cell">Action</div>

      <div className="product-table-cell">Image</div>
      {renderInputColumn("Product Name", "productName")}
      {renderInputColumn("Description", "description")}
      {renderInputColumn("Category Name", "categoryName")}
      {renderInputColumn("MRP", "mrp")}
      {renderInputColumn("Selling Price", "sellingPrice")}
      {renderInputColumn("Company Name", "companyName")}
      {renderInputColumn("Coins", "coins")}

      <div className="product-table-cell">
        <p>
          Status{" "}
          <SortButton
            column="status"
            currentSortColumn={currentSortColumn}
            currentSortOrder={currentSortOrder}
            onSortChange={onSortChange}
          />
        </p>
        <select
          name="status"
          value={columnSearch.status}
          onChange={(e) =>
            setColumnSearch({ ...columnSearch, status: e.target.value })
          }
        >
          <option value="Active">Active</option>
          <option value="Deactive">Deactive</option>
        </select>
      </div>

      {renderInputColumn("Stock", "stock")}
      {renderInputColumn("Created By", "createdBy")}
      {renderDateColumn("Last Updated", "lastUpdated")}
    </div>
  );
};

export default ProductListHeader;